export default function initFilter() {
    const $ = jQuery
    const formatState = (state) => {
        if (!state.id) {
            return state.text;
        }
        const $state = $('<strong></strong>');
        $state.text(state.text);
        $('.clearWrap').show()
        return $state;
    };
    $(".filterSelect").each(function(){
        $(this).select2({
            placeholder: $(this).data('type'),
            selectOnClose: true,
            minimumResultsForSearch: Infinity,
            dropdownParent: $(this).parent(),
            templateSelection: formatState
        });
    })
}